import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { WalletOwnerArgs } from '../api/types/payments.types';

import { fetchWalletInstruments } from '../api/wallet.api';

export const walletQueryKeys = createQueryKeys('wallet', {
  fetchInstruments: (args: WalletOwnerArgs) => ({
    queryFn: () => fetchWalletInstruments(args),
    queryKey: [
      args.ownerType,
      args.ownerType === 'organization' ? args.organizationId : 'me',
    ],
  }),
});
